export const optionsYear = [        
    {value: 2013, text: "2013"},
    {value: 2014, text: "2014"},
    {value: 2015, text: "2015"},
    {value: 2016, text: "2016"},
    {value: 2017, text: "2017"},
    {value: 2018, text: "2018"},
    {value: 2019, text: "2019"},
    {value: 2020, text: "2020"},
    {value: 2021, text: "2021"},
    {value: 2022, text: "2022"},
    {value: 2023, text: "2023"},
    {value: 2024, text: "2024"}
]
export const optionsMonth = [    
    {value: 1, text: "Enero"},
    {value: 2, text: "Febrero"},
    {value: 3, text: "Marzo"},
    {value: 4, text: "Abril"},
    {value: 5, text: "Mayo"},
    {value: 6, text: "Junio"},
    {value: 7, text: "Julio"},
    {value: 8, text: "Agosto"},
    {value: 9, text: "Septiembre"},
    {value: 10, text: "Octubre"},
    {value: 11, text: "Noviembre"},
    {value: 12, text: "Diciembre"}
]